import moment from 'moment/moment';

export const dateFormat = (
  date: string | number[],
  {
    addHours = 3,
    format,
  }: {
    addHours: number;
    format?: string;
  },
) => {
  return moment(date)
    .add(addHours, 'hours')
    .format(format || 'DD.MM.YYYY, HH:mm');
};

export const numGroup = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return '-';
  if (typeof value !== 'number') return value;
  return value
    ?.toString()
    .split(/(?=(?:...)*$)/)
    .join(' ');
};
